export interface FloatingButtonConfig {
  id: string;
  enabledCustomer?: string[]; // empty = all customers
  enabledEnvironments?: Array<'development' | 'staging' | 'production'>;
  disabledCustomer?: string[]; // explicitly disabled customers
}

export const floatingButtonsConfig: FloatingButtonConfig[] = [
  {
    id: 'chatbotButton',
    enabledCustomer: [], // empty = all customers
    disabledCustomer: [], // explicitly disable for these customers
    enabledEnvironments: ['development', 'production'],
  },
];
